var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from "react";
import { useDispatch } from "react-redux";
import { getBeneficiary } from "../../../store/beneficiary/actions";
import { insured } from "../../../store/insured/actions";
import { personByIdClearData } from "../../../store/person/actions";
import { policyCancel } from "../../../store/policy/actions";
import { cancelQuote } from "../../../store/cancelQuote/actions";
import { quoteAllClearData } from "../../../store/generateQuote/actions";
import { typeAlert } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { useLocation, useNavigate } from "react-router-dom";
import { updateStepByPath } from "ah_utility/workflow";
import { backStepByPath } from "../../../utils/updateStepBack";
import { insertIntoStepInformation } from "../../../utils/upsertStepInformation";
import { useStepNavigation } from "ah_utility/NavigationEngine";
var useUI = function (setShowBeneficiariesModal, setShowInsuredModal, id, STEP, isValid, setSeeToast, setOpenModalConfirm, setPolicyId, setType, setCodigo, setStatus, setModalTitle, setTriggerCatalogs, instanceId, workFlowId, currentStep, nextStep, runComplete, sessionData, dataAddress, documentNumber, documentType) {
    var dispatch = useDispatch();
    var navigate = useNavigate();
    var pathname = useLocation().pathname;
    var pathLocation = "/" + pathname.split("/")[1];
    var _a = React.useState(false), triggerProject = _a[0], setTriggerProject = _a[1];
    var _b = React.useState(""), projectId = _b[0], setProjectId = _b[1];
    var _c = React.useState(null), dataRow = _c[0], setDataRow = _c[1];
    // Hook del motor de navegación
    var _d = useStepNavigation({
        currentStepId: pathLocation,
        sessionData: sessionData,
        autoValidate: true,
    }), navigation = _d.navigation, isLastPage = _d.isLastPage;
    var handleClickContextMenu = function (item, row) {
        var data = row.row;
        var productId = data === null || data === void 0 ? void 0 : data.productId;
        if (item.name === "Beneficiarios") {
            dispatch(getBeneficiary({
                enable: true,
                page: 1,
                limit: 100,
                quoteId: data.id,
            }));
            setShowBeneficiariesModal(true);
        }
        if (item.name === "Asegurados") {
            dispatch(insured({
                enable: true,
                page: 1,
                limit: 100,
                quoteId: data.id,
            }));
            setShowInsuredModal(true);
        }
        if (item.name === "Ver detalles") {
            if (data.estado === "Expirada" ||
                data.estado === "Cancelada" ||
                data.estado === "Emitida") {
                navigate("/confirmationForm/".concat(data.id, "/false/false/").concat(productId));
            }
            else {
                localStorage.removeItem("WorkFlowId");
                localStorage.removeItem("Quote");
                localStorage.removeItem("steps");
                localStorage.removeItem("summary");
                localStorage.removeItem("afy-variables");
                localStorage.removeItem("afy-action-flags");
                setProjectId(productId);
                setTriggerProject(true);
                setDataRow(data);
            }
        }
        if (item.name === "Cancelar") {
            // Safety check: Don't allow cancellation of already cancelled or expired policies
            if (data.estado === "Cancelada" ||
                data.estado === "cancelada" ||
                data.estado === "Expirada" ||
                data.estado === "expirada") {
                setSeeToast({
                    show: true,
                    message: "No se puede cancelar una póliza que ya está " +
                        data.estado.toLowerCase(),
                    type: typeAlert.warning,
                });
                return;
            }
            if (data.policyId === null || data.policyId === undefined) {
                setModalTitle("cotización");
                setPolicyId(data.id); // Use quote ID for quotes
                setType(false); // false for quote, true for policy
                setCodigo(data.cotizacion);
            }
            else {
                setModalTitle("póliza");
                setPolicyId(data.policyId); // Use policy ID for policies, fallback to quote ID
                setType(true); // true for policy
                setCodigo(data.poliza);
            }
            setStatus(data.estado);
            setTriggerCatalogs(true); // Trigger catalog loading
            setOpenModalConfirm(true);
        }
    };
    var handleCancelPolicy = function (reasonId, type, policyId) {
        //get current date and time
        var currentDateAndTime = new Date();
        var currentDate = currentDateAndTime.toISOString();
        if (type) {
            // Cancel policy
            var dataSubmit = {
                data: {
                    date: currentDate,
                    userId: "d2bd577e-c8c6-4519-b30a-b8e674c42952",
                    policyId: policyId,
                    catalogReasonCancellation: reasonId,
                },
            };
            dispatch(policyCancel(dataSubmit));
        }
        else {
            // Cancel quote
            dispatch(cancelQuote({
                id: policyId,
            }));
        }
    };
    var handleClickPrevious = function (e) {
        if (id) {
            navigate("/clients");
        }
        else {
            dispatch(personByIdClearData());
            dispatch(quoteAllClearData());
            backStepByPath(pathname);
            navigate("".concat(navigation === null || navigation === void 0 ? void 0 : navigation.back));
        }
    };
    var handleClickNext = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var res, prevStep, currentStep_1, nextStep_1, err_1;
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    if (!(isValid() === true)) return [3 /*break*/, 5];
                    dispatch(personByIdClearData());
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, runComplete({
                            workFlowId: workFlowId,
                            instanceId: instanceId,
                            currentStep: currentStep,
                            nextStep: nextStep,
                        })];
                case 2:
                    res = _e.sent();
                    if (res) {
                        updateStepByPath(pathname, {
                            addressData: dataAddress,
                            personData: {
                                documentNumber: documentNumber,
                                identificationTypeId: documentType,
                            },
                        });
                        prevStep = (_a = res.upcomingFormStep) === null || _a === void 0 ? void 0 : _a.prevSteps[0];
                        currentStep_1 = (_b = res.upcomingFormStep) === null || _b === void 0 ? void 0 : _b.id;
                        nextStep_1 = (_c = res.upcomingFormStep) === null || _c === void 0 ? void 0 : _c.nextSteps[0];
                        insertIntoStepInformation({
                            stepKey: pathname,
                            data: {
                                currentStep: currentStep_1,
                                nextStep: nextStep_1,
                                prevStep: prevStep,
                            },
                        });
                        navigate("".concat(navigation === null || navigation === void 0 ? void 0 : navigation.next));
                    }
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _e.sent();
                    setSeeToast({
                        show: true,
                        message: (_d = err_1 === null || err_1 === void 0 ? void 0 : err_1.message) !== null && _d !== void 0 ? _d : "Ocurrió un error al completar el paso.",
                        type: typeAlert.error,
                    });
                    return [3 /*break*/, 4];
                case 4: return [3 /*break*/, 6];
                case 5:
                    /*Cuando no se tiene ningun plan selecionado */
                    setSeeToast({
                        show: true,
                        message: "¡Debe ingresar un documento válido!",
                        type: typeAlert.info,
                    });
                    _e.label = 6;
                case 6: return [2 /*return*/];
            }
        });
    }); };
    return {
        handleClickContextMenu: handleClickContextMenu,
        handleClickPrevious: handleClickPrevious,
        handleClickNext: handleClickNext,
        handleCancelPolicy: handleCancelPolicy,
        isNextDisabled: (navigation === null || navigation === void 0 ? void 0 : navigation.canNavigateNext) === false,
        projectId: projectId,
        triggerProject: triggerProject,
        dataRow: dataRow,
        isLastPage: isLastPage,
    };
};
export default useUI;
